// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"57598e8b","291":"ef7fd146","403":"ae91bcd1","755":"32f63c1e","989":"9e58216d"}[chunkId] + ".chunk.js";
};